var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pwa-prompt dialog-box dialog-box-vue" }, [
    _c(
      "div",
      { staticClass: "close-button", on: { click: _vm.closeDialogBox } },
      [_c("img", { attrs: { src: "/images/ui/exit-button.png" } })]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "pwa-heading" }, [
      _c("h3", [_vm._v("Need help? Our support team is ready to assist you.")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      !_vm.hideWhatsappWidget
        ? _c("div", { staticClass: "pwa-buttons" }, [
            _c(
              "a",
              {
                staticClass: "conatct-us-btn",
                attrs: {
                  href: "https://api.whatsapp.com/send/?phone=601111673277&text&type=phone_number&app_absent=0",
                  target: "_blank",
                },
              },
              [
                _c("button", [
                  _c(
                    "svg",
                    {
                      staticClass: "message-us-button_logo",
                      attrs: {
                        viewBox: "0 0 20 20",
                        width: "20px",
                        height: "20px",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          d: "M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,\n              20 C8.21764336,20 6.50261894,19.5321866 4.99604377,18.6597493 L1.09644722,19.9573724 C0.445123153,\n              20.1741059 -0.17423773,19.5545345 0.0427170752,18.9032841 L1.34118515,15.0055699 C0.468152857,\n              13.4986162 4.48352336e-12,11.7830015 4.48352336e-12,10 C4.48352336e-12,4.4771525 4.4771525,0 10,\n              0 Z M10,1.66666667 C5.39762709,1.66666667 1.66666667,5.39762709 1.66666667,10 C1.66666667,\n              11.6017128 2.11850111,13.1345631 2.95730951,14.4569627 C3.09146627,14.6684637 3.1233805,\n              14.929089 3.04422002,15.1667113 L2.15025713,17.8501903 L4.83522181,16.956746 C5.07271735,\n              16.8777174 5.33315744,16.9096255 5.54455056,17.0436501 C6.86661689,17.8818489 8.39890565,18.3333333 10,\n              18.3333333 C14.6023729,18.3333333 18.3333333,14.6023729 18.3333333,10 C18.3333333,5.39762709 14.6023729,\n              1.66666667 10,1.66666667 Z M6.55072391,5.00454308 C6.71472826,5.00454308 6.87873262,\n              5.00454308 7.02048512,\n              5.01164697 C7.1713032,5.02141482 7.37404224,4.94859994 7.57430887,5.46540794 C7.78034448,\n              5.99642371 8.27235754,7.30442746 8.33334408,7.43584942 C8.39515477,7.56727138 8.43636189,\n              7.72355696 8.35559593,7.90026623 C8.27318168,8.07786348 8.23032628,8.18886176 8.10835319,\n              8.34070741 C7.98555596,8.49699298 7.85039659,8.68791003 7.73831322,8.80512421 C7.61551599,\n              8.93832215 7.48694976,9.08039995 7.63199884,9.34679582 C7.77375134,9.61052774 8.26906097,\n              10.4807543 9.00007535,11.1822634 C9.94042191,12.0871214 10.7324228,12.368613 10.9796656,\n              12.500035 C11.2244359,12.6323449 11.369485,12.6074813 11.5112375,12.434324 C11.6554624,\n              12.2576147 12.1252236,11.66 12.2900521,11.3936041 C12.4540565,11.1298722 12.618885,\n              11.1716076 12.8438758,\n              11.2621822 C13.0688667,11.3492048 14.279532,11.9903309 14.5243024,12.1217528 C14.7723692,\n              12.2567268 14.9363736,12.3233257 14.9973601,12.434324 C15.0591708,12.5453223 15.0591708,\n              13.0763381 14.8556076,13.6934885 C14.649572,14.3141909 13.6680183,14.8798381 13.1949605,\n              14.955317 C12.769703,15.0219159 12.2323621,15.0494435 11.6431003,14.8487586 C11.1671235,\n              14.6897973 10.6994329,14.5033465 10.2420581,14.2902153 C7.77375134,13.1411611 6.16090452,\n              10.4638825 6.03893144,10.2907252 C5.91531006,10.113128 5.03347762,8.8512995 5.03347762,\n              7.5468477 C5.03347762,6.24328389 5.66806732,5.60126983 5.89305822,5.33753792 C6.11887326,\n              5.07025406 6.38589542,5.00454308 6.55072391,5.00454308 Z",
                          fill: "#25D366",
                        },
                      }),
                    ]
                  ),
                  _vm._v("\n          Whatsapp\n        "),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Support Line:")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "tel:1800819748" } }, [_vm._v("1800819748")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Email:")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "mailto:mycs@content-clubs.com" } }, [
        _vm._v("mycs@content-clubs.com"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Subscription:")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "https://checksubscription.com/?c=my" } }, [
        _vm._v("https://checksubscription.com/?c=my"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }